<template>
  <div class="modal" id="modal-basic">
    <div class="modal-container">
      <slot name="modal-body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicModal',
};
</script>

<style scoped lang="scss">
</style>
